import { Component, OnInit } from '@angular/core';
import { MetamanagerService } from '../metamanager.service';
import { InitScripts } from '../app.constants';

@Component({
  selector: 'app-tnc',
  templateUrl: './tnc.component.html',
  styleUrls: ['./tnc.component.css']
})
export class TncComponent implements OnInit {
  constructor(private metaManager: MetamanagerService) {
    new InitScripts().loadScripts();
  }

  ngOnInit(): void {
    this.metaManager.updateMetaTitle("Terms and conditions Details | sarvadhnya.com",
      "आदिकरण श्री दत्तात्रेय प्रभू, श्री गुरुवर्य आणि अखिल परमार्ग",
      "");
  }
}
